<div
  class="card-form-group-container"
  [formGroup]="form">
  <app-input-vocabulary-autocomplete
    formControlName="ACQT"
    [vocabularyName]="'V_ACQT'"
    [placeholder]="'Tipo acquisizione (ACQT)'">
  </app-input-vocabulary-autocomplete>
  <mat-form-field>
    <input
      matInput
      placeholder="Nome (ACQN)"
      formControlName="ACQN">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Data acquisizione (ACQD)"
      formControlName="ACQD">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Luogo acquisizione (ACQL)"
      formControlName="ACQL">
  </mat-form-field>
</div>
